/**
 * Preview result summary buckets for toolbar chips and panel headers.
 */

import type { FlowLayer, FlowOptimizerItemPreview } from '@trafficpulse/shared';

export interface PreviewSummaryBuckets {
  changed: number;
  unchanged: number;
  passThrough: number;
  deltaPerLayer: Record<FlowLayer, number>;
}

export function summarizePreviewItems(
  items: FlowOptimizerItemPreview[],
): PreviewSummaryBuckets {
  const buckets: PreviewSummaryBuckets = {
    changed: 0,
    unchanged: 0,
    passThrough: 0,
    deltaPerLayer: { paths: 0, landers: 0, offers: 0 },
  };
  for (const it of items) {
    if (it.passThrough) buckets.passThrough++;
    else if (it.deltaPerMille === 0) buckets.unchanged++;
    else buckets.changed++;
    buckets.deltaPerLayer[it.layer] += Math.abs(it.deltaPerMille);
  }
  for (const layer of Object.keys(buckets.deltaPerLayer) as FlowLayer[]) {
    buckets.deltaPerLayer[layer] = Math.round(buckets.deltaPerLayer[layer] / 2);
  }
  return buckets;
}

export function previewChipLabel(buckets: PreviewSummaryBuckets): string {
  return `${buckets.changed} changed`;
}
